// Logos oficiais de bancos (DTGD-1311), recortadas a partir dos SVGs
// fornecidos pelo time — cada arquivo fonte trazia 3 variantes lado a lado
// (logo completa, ícone e ícone em bloco colorido); aqui cada variante já
// foi recortada para seu próprio arquivo (ver src/images/banks/), só com
// um recorte de viewBox — a arte original não foi alterada.
//
// `tile`: ícone em bloco na cor institucional — usado no badge da tabela.
// `mark`: logo completa (nome + símbolo) — usada no cabeçalho do boleto.
// Ter uma logo aqui é só sobre exibição/reconhecimento visual — não define
// se o banco é homologado para segunda via pelo portal (ver
// bancosHomologados.js, que é a lista que controla essa regra de negócio).
// Bancos fora desta lista não têm logo — a UI cai para texto simples.
import bbTile from '../images/banks/001-tile.svg';
import bbMark from '../images/banks/001-mark.svg';
import bndesTile from '../images/banks/007-tile.svg';
import bndesMark from '../images/banks/007-mark.svg';
import santanderTile from '../images/banks/033-tile.svg';
import santanderMark from '../images/banks/033-mark.svg';
import interTile from '../images/banks/077-tile.svg';
import interMark from '../images/banks/077-mark.svg';
import xpTile from '../images/banks/102-tile.svg';
import xpIcon from '../images/banks/102-icon.svg';
import caixaTile from '../images/banks/104-tile.svg';
import caixaMark from '../images/banks/104-mark.svg';
import unicredTile from '../images/banks/136-tile.svg';
import unicredMark from '../images/banks/136-mark.svg';
import btgTile from '../images/banks/208-tile.svg';
import btgMark from '../images/banks/208-mark.svg';
import originalTile from '../images/banks/212-tile.svg';
import originalMark from '../images/banks/212-mark.svg';
import bradescoTile from '../images/banks/237-tile.svg';
import bradescoMark from '../images/banks/237-mark.svg';
import nubankTile from '../images/banks/260-tile.svg';
import nubankIcon from '../images/banks/260-icon.svg';
import pagbankTile from '../images/banks/290-tile.svg';
import pagbankMark from '../images/banks/290-mark.svg';
import mercadoPagoTile from '../images/banks/323-tile.svg';
import mercadoPagoMark from '../images/banks/323-mark.svg';
import c6Tile from '../images/banks/336-tile.svg';
import c6Mark from '../images/banks/336-mark.svg';
import itauTile from '../images/banks/341-tile.svg';
import itauIcon from '../images/banks/341-icon.svg';
import safraTile from '../images/banks/422-tile.svg';
import safraMark from '../images/banks/422-mark.svg';
import panTile from '../images/banks/623-tile.svg';
import panMark from '../images/banks/623-mark.svg';
import bvTile from '../images/banks/655-tile.svg';
import bvIcon from '../images/banks/655-icon.svg';
import citiTile from '../images/banks/745-tile.svg';
import citiIcon from '../images/banks/745-icon.svg';
import sicredTile from '../images/banks/748-tile.svg';
import sicredMark from '../images/banks/748-mark.svg';
import sicoobTile from '../images/banks/756-tile.svg';
import sicoobMark from '../images/banks/756-mark.svg';
import normalizeCodigoBanco from './normalizeCodigoBanco';

// Bancos cujo material de origem não tinha uma variante "logo completa"
// (nome + símbolo) separada — só o ícone. Usamos o próprio ícone como `mark`.
const BANCO_LOGOS = {
  '001': { tile: bbTile, mark: bbMark },
  '007': { tile: bndesTile, mark: bndesMark },
  '033': { tile: santanderTile, mark: santanderMark },
  '077': { tile: interTile, mark: interMark },
  '102': { tile: xpTile, mark: xpIcon },
  '104': { tile: caixaTile, mark: caixaMark },
  '136': { tile: unicredTile, mark: unicredMark },
  '208': { tile: btgTile, mark: btgMark },
  '212': { tile: originalTile, mark: originalMark },
  '237': { tile: bradescoTile, mark: bradescoMark },
  '260': { tile: nubankTile, mark: nubankIcon },
  '290': { tile: pagbankTile, mark: pagbankMark },
  '323': { tile: mercadoPagoTile, mark: mercadoPagoMark },
  '336': { tile: c6Tile, mark: c6Mark },
  '341': { tile: itauTile, mark: itauIcon },
  '422': { tile: safraTile, mark: safraMark },
  '623': { tile: panTile, mark: panMark },
  '655': { tile: bvTile, mark: bvIcon },
  '745': { tile: citiTile, mark: citiIcon },
  '748': { tile: sicredTile, mark: sicredMark },
  '756': { tile: sicoobTile, mark: sicoobMark },
};

export function getBancoLogo(codigoBanco) {
  const alvo = normalizeCodigoBanco(codigoBanco);
  if (!alvo) return undefined;
  const entry = Object.entries(BANCO_LOGOS).find(
    ([codigo]) => normalizeCodigoBanco(codigo) === alvo,
  );
  return entry ? { codigo: entry[0], ...entry[1] } : undefined;
}

export default BANCO_LOGOS;
